export default __webpack_public_path__ + "static/image 3-bf3a312975e1313d45e7468407771b3b.jpeg";